<template>
  <div class="sticky-container">
    <div ref="sticky-el" class="sticky-container__element-wrap">
      <div class="sticky-container__el">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
  import('../helpers/resizeSensor')
  import StickySidebar from 'sticky-sidebar'

  export default {
    props: {
      topSpacing: {
        type: Number,
        default: 20
      },
      bottomSpacing: {
        type: Number,
        default: 20
      }
    },
    data() {
      return {
        stickySidebar: null,
        timer: null,
        timerCreate: null,
      }
    },
    methods: {
      setSticky() {
        this.stickySidebar = new StickySidebar(this.$refs['sticky-el'], {
          topSpacing: this.topSpacing,
          bottomSpacing: this.bottomSpacing,
          resizeSensor: true,
          containerSelector: '.sticky-container',
          innerWrapperSelector:  '.sticky-container__el',
        })
      },
      onResize() {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          if(!this.stickySidebar) return
          this.stickySidebar.destroy()
          this.setSticky()
        }, 300)
      }
    },
    mounted() {
      this.timerCreate = setTimeout(() => {
        this.setSticky()
        window.addEventListener("resize", this.onResize)
      }, 300)
    },
    beforeDestroy() {
      if(this.stickySidebar) this.stickySidebar.destroy()
      window.removeEventListener("resize", this.onResize)
      clearTimeout(this.timer)
      clearTimeout(this.timerCreate)
    }
  }
</script>

<style lang="less">

</style>
